import {append, without} from 'ramda';

export const togglePersonnelOverviewUserId = (selectedIds: string[], userId: string): string[] =>
  selectedIds.includes(userId) ? without([userId], selectedIds) : append(userId, selectedIds);
